import React, { useContext } from 'react';
import SnackbarContext from 'new/contexts/SnackbarContext';

/**
 * Higher-Order Component that provides SnackbarContext methods to class components.
 * Passes showSuccess, showError, showWarning, and showInfo as props to the wrapped component.
 */
export function withSnackbar(WrappedComponent) {
  const WithSnackbarComponent = (props) => {
    const context = useContext(SnackbarContext);

    // Handle case where SnackbarContext is not available
    const snackbarMethods = context || {
      showSuccess: () => console.warn('SnackbarContext not available'),
      showError: () => console.warn('SnackbarContext not available'),
      showWarning: () => console.warn('SnackbarContext not available'),
      showInfo: () => console.warn('SnackbarContext not available'),
    };

    const { showSuccess, showError, showWarning, showInfo } = snackbarMethods;

    return (
      <WrappedComponent
        {...props}
        showSuccess={showSuccess}
        showError={showError}
        showWarning={showWarning}
        showInfo={showInfo}
      />
    );
  };

  WithSnackbarComponent.displayName = `withSnackbar(${
    WrappedComponent.displayName || WrappedComponent.name || 'Component'
  })`;

  return WithSnackbarComponent;
}

export default withSnackbar;
